export default {
    methods: {
        setStation(param) {
            const station = param || 'brak';
            if (
                this.$store &&
                this.$store.state &&
                this.$store.state.stationsData
            ) {
                const stations = this.$store.state.stationsData;
                const keys = Object.keys(stations);

                if (keys.indexOf(station) !== -1) {
                    return {
                        name: stations[station].name,
                        regional: stations[station].regional,
                        url: stations[station].logo_src,
                        background: stations[station].logo_background_color,
                        tvUrl: stations[station].url,
                        code: stations[station].code
                    };
                }
            }
            return {};
        }
    }
};
